import debounce from 'lodash/debounce';
import { isMobile } from '@common/utils/responsive';
import { Modal } from '@common/vanilla_ui/general';
import { modalEvents } from '@common/vanilla_ui/general/modal';
import RequestCallbackFrom from
  '@scaler_landing/pages/contact_us_widget/requestCallback';
import {
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import { setCTAId } from './cta';
import { CALLBACK_MODES, QUERY_PARAMS } from './constants';
import Tracking from './tracking';

const REQUEST_CALLBACK_CONTAINER = 'request-callback-container';
const CONTACT_US_WIDGET_CONTAINER = 'contact-us-widget-container';
const CONTACT_US_WIDGET_BUTTON = 'contact-us-widget';
const REQUEST_CALLBACK_SUCCESS_CONTAINER = 'request-callback-success';
const CONTEXTUAL_CALLBACK_SUCCESS_CONTAINER = 'contextual-request-'
                                              + 'callback-success';
const REQUEST_CALLBACK_FORM = 'request-callback-form';
const CONTACT_US_STRIP = 'contact-us-strip';
const INFO_TEXT_STRIP = 'contact-us-widget__item--text';
const REQUEST_CALLBACK_STRIP = 'request-callback-strip';
const REQUEST_CALLBACK_MODAL = 'request-callback-modal';
const LEAD_DETAILS_MODAL_ID = 'lead-details-modal';
const CALLBACK_MODE_ATTR_ID = 'data-callback-mode';
const DEFAULT_PROGRAM = 'academy';
const DEFAULT_RCB_INTENT = 'rcb_widget';
const rcbModelVariant = 'new_rcb_modal';
const defaultVariant = 'old_rcb_modal';

const REQUEST_CALLBACK_STRIP_DISABLED_PAGES = [
  '/enterprise',
  '/settings/scaler',
  '/careers',
  '/careers-business',
  '/scaler-verse',
];

const RCB_CONTACT_US_POPUP_DISABLED_PAGES = [
  '/events',
  '/event',
];

const RCB_TALK_TO_US_POPUP_PAGES = [
  '/academy',
  '/devops-course',
  '/data-science-course',
  '/courses',
];

const REQUEST_CALLBACK_CTAS = [
  ['us-academy-request-callback', 'rcb'], // Should nt be here
  ['tuition-fee-request-callback', 'rcb'],
  ['banner-webinar-request-callback', 'landing'],
  ['banner-request-callback', 'rcb'],
  ['people-webinar-request-callback', 'landing'],
  ['masterclass-webinar-request-callback', 'landing'],
  ['masterclass-request-callback', 'rcb'],
  ['header-request-callback', 'landing'],
  ['fab-request-callback', 'landing'],
  ['course-fab-request-callback', 'landing'],
  ['course-banner-request-callback', 'landing'],
  ['faq-webinar-request-callback', 'landing'],
  [`${REQUEST_CALLBACK_STRIP}-action`, 'rcb', DEFAULT_PROGRAM, 'rcb_strip'],
  [
    `${REQUEST_CALLBACK_STRIP}-action-post-reg`,
    'rcb', DEFAULT_PROGRAM, 'rcb_strip',
  ],
  ['event-request-callback', 'rcb'],
  ['academy-request-callback', 'rcb', DEFAULT_PROGRAM,
    'rcb_academy_program_card'],
  ['data-science-request-callback', 'rcb', 'data_science',
    'rcb_data_science_program_card'],
  ['neovarsity-request-callback', 'rcb', 'neovarsity',
    'rcb_neovarsity_program_card'],
  ['devops-program-card-request-callback', 'rcb', 'devops',
    'rcb_devops_program_card'],
  ['data-science-banner-request-callback', 'rcb', 'data_science',
    'rcb_landing_page_banner'],
  ['devops-request-callback', 'rcb', 'devops',
    'devops_landing_page_cta'],
  ['aiml-request-callback', 'rcb', 'ai_ml',
    'aiml_landing_page_cta'],
  ['navbar-request-callback', 'rcb', 'landing',
    'navbar_rcb_cta'],
  ['rcb-header-strip-action', 'rcb', DEFAULT_PROGRAM, 'header_rcb_strip'],
  ['widget-strip-banner-request-callback', 'rcb', DEFAULT_PROGRAM,
    'widget_strip_banner_rcb_cta'],
  ['price-hike-rcb-strip-action',
    'rcb', DEFAULT_PROGRAM, 'price_hike_rcb_strip'],
  ['pricing-section-request-callback',
    'rcb', DEFAULT_PROGRAM, 'pricing_banner_rcb_cta'],
];

const REQUEST_CALLBACK_CTAS_IN_CLICKABLE_CARDS = [
  'devops-program-card-request-callback',
  'academy-request-callback',
  'data-science-request-callback',
  'neovarsity-request-callback',
  'pricing-section-request-callback',
];

const PROGRAM_VALUE_MAPPING = {
  academy: 'Academy',
  data_science: 'Data Science',
  neovarsity: 'MS in CSE',
  devops: 'Devops',
};

const PROGRAM_PRODUCT_MATCHING = {
  academy: 'software_development',
  data_science: 'data_science',
  neovarsity: 'neovarsity',
  devops: 'devops',
};

let callBackRequested = false;
let isDefaultCountry = true;

const toggleDisplayStyle = (element, displayValue) => {
  const el = element;
  if (el) {
    el.style.display = displayValue;
  }
};

const getExperimentValue = (experimentKey) => {
  const experimentContainer = document.querySelector(
    `[data-variant-key=${experimentKey}]`,
  );

  const experimentValue = experimentContainer?.getAttribute(
    'data-variant-value',
  );
  return experimentValue || defaultVariant;
};

export default function initialiseOldRcb() {
  const variantValue = getExperimentValue('growth-tech_new-rcb-modal');
  const variantValue2 = getExperimentValue(
    'growth-tech_combined-rcb-modal',
  );
  const formFlowEl = document.querySelector('#request-callback-form');
  isDefaultCountry = formFlowEl?.getAttribute(
    'data-default-country',
  ) === 'true';
  const phoneVerified = formFlowEl?.getAttribute(
    'data-phone-verified',
  ) === 'true';
  const requestCallbackHiddenClass = `${REQUEST_CALLBACK_CONTAINER}--hidden`;
  const requestCallbackStripEl = document.getElementById(
    REQUEST_CALLBACK_STRIP,
  );
  // const requestCallbackStripActionEl = document.getElementById(
  //   `${REQUEST_CALLBACK_STRIP}-action`,
  // );
  const contactUsContainer = document.getElementById(
    CONTACT_US_WIDGET_CONTAINER,
  );
  const widgetButton = document.getElementById(
    CONTACT_US_WIDGET_BUTTON,
  );
  const phoneWidget = document.getElementById('phone-widget');
  const callUsPhoneWidget = document.getElementById('call-us-phone-widget');
  const chatWidget = document.getElementById('chat-widget');
  const whatsAppWidget = document.getElementById('whatsapp-widget');
  const widgetIcon = document.getElementById('widget-icon');
  const widgetClose = document.getElementById('widget-close');
  const floatingContainer = document.getElementById(
    REQUEST_CALLBACK_CONTAINER,
  );
  const requestCallbackSuccessEl = document.getElementById(
    REQUEST_CALLBACK_SUCCESS_CONTAINER,
  );
  const contextualCallbackSuccessEl = document.getElementById(
    CONTEXTUAL_CALLBACK_SUCCESS_CONTAINER,
  );
  // const requestCallbackFormEl = document.getElementById(
  //   REQUEST_CALLBACK_FORM,
  // );
  const requestCallbackFormEl = formFlowEl;
  const requestCallbackFormCloseEl = document.getElementById(
    `${REQUEST_CALLBACK_FORM}-close`,
  );

  const contactUsStripEl = document.getElementById(CONTACT_US_STRIP);

  let otpSubmitButton;
  const submitButton = document.getElementsByClassName(
    `${REQUEST_CALLBACK_FORM}__submit`,
  );
  if (submitButton.length > 0) {
    [otpSubmitButton] = submitButton;
  }
  const otpFormEl = document.getElementById(`${REQUEST_CALLBACK_FORM}-otp`);
  const submitFormEl = document.getElementById(
    `${REQUEST_CALLBACK_FORM}-submit`,
  );
  const resendOtpFormEl = document.querySelector(
    `.${REQUEST_CALLBACK_FORM}__otp-hint`,
  );

  const pathName = window.location.pathname;
  if (
    pathName
    && !REQUEST_CALLBACK_STRIP_DISABLED_PAGES.includes(
      pathName.replace(/\/+$/g, ''),
    )
    && !(requestCallbackStripEl.dataset.hideStrip === 'true')
  ) {
    requestCallbackStripEl.classList.remove(
      `${REQUEST_CALLBACK_STRIP}--hidden`,
    );
  }

  const toggleCallUsWidget = (displayStyle) => {
    if (isMobile()) {
      toggleDisplayStyle(callUsPhoneWidget, displayStyle);
    }
  };

  const isWidgetOpen = () => {
    if (contactUsContainer.style.display === 'none') {
      return true;
    }
    if (widgetClose.style.display !== 'none') {
      return true;
    }

    return false;
  };

  const disableOtpButton = () => {
    otpSubmitButton?.classList?.add('is-disabled');
  };

  const enableOtpForm = () => {
    otpFormEl?.classList?.remove('hidden');
    submitFormEl?.classList?.add('hidden');
    resendOtpFormEl?.classList?.add('hidden');
  };

  const onCloseResetForm = () => {
    disableOtpButton();
    submitFormEl?.reset();
    otpFormEl?.reset();
    enableOtpForm();
  };

  const resetForm = () => {
    requestCallbackFormEl.classList.remove(`${REQUEST_CALLBACK_FORM}--hidden`);

    if (!requestCallbackSuccessEl.classList.contains(
      `${REQUEST_CALLBACK_SUCCESS_CONTAINER}--hidden`,
    ) || !contextualCallbackSuccessEl.classList.contains(
      'contextual-request-callback-form__success--hidden',
    )) {
      callBackRequested = true;
    }

    if (!phoneVerified) {
      if (!callBackRequested) {
        onCloseResetForm();
        // do not reset the form once callback has been requested.
      } else {
        enableOtpForm();
      }
    }
    requestCallbackSuccessEl.classList.add(
      `${REQUEST_CALLBACK_SUCCESS_CONTAINER}--hidden`,
    );
    contextualCallbackSuccessEl.classList.add(
      'contextual-request-callback-form__success--hidden',
    );
  };

  const selectCallbackProgram = (program) => {
    if (!program) return;

    const programDataValue = PROGRAM_VALUE_MAPPING[program]
    || PROGRAM_VALUE_MAPPING[DEFAULT_PROGRAM];
    const selectOptions = floatingContainer.querySelector(
      `#${REQUEST_CALLBACK_FORM}__program`,
    );
    if (selectOptions) {
      const options = selectOptions.querySelector(
        '.sr-select__dropdown',
      );
      const selectProgram = options?.querySelector(
        `.sr-select__option[data-value='${programDataValue}']`,
      );
      selectProgram?.click();
    }
  };

  const openCalendlyModal = (callbackCtaId) => {
    const calendlyUrlAttrId = callbackCtaId === 'rcb'
      ? 'data-rcb-calendly-url' : 'data-calendly-url';
    const calendlyUrl = formFlowEl.getAttribute(calendlyUrlAttrId);
    if (calendlyUrl) {
      const hideParam = 'hide_event_type_details=1&hide_gdpr_banner=1';
      const queryParam = `?${hideParam}`;
      // ${emailParam}${phoneNumberParam}`;

      window.Calendly.initPopupWidget({
        url: `${calendlyUrl}${queryParam}`,
      });
    }
  };
  const openCallbackContainer = (
    {
      callbackCtaId = 'rcb', freezeModal = false, program,
    },
  ) => {
    setCTAId(callbackCtaId);
    const attrId = callbackCtaId === 'rcb'
      ? 'data-rcb-enable-mobile-authentication'
      : 'data-enable-mobile-authentication';
    const shouldAuthenticateMobile = formFlowEl.getAttribute(attrId) === 'true';
    if (shouldAuthenticateMobile) {
      if (!isDefaultCountry) {
        Modal.open(REQUEST_CALLBACK_MODAL);
        toggleDisplayStyle(widgetIcon, '');
        toggleDisplayStyle(widgetClose, 'none');
        resetForm();
      } else {
        floatingContainer.classList.remove(requestCallbackHiddenClass);
        selectCallbackProgram(program);
      }
    } else {
      widgetClose.style.display = 'none';
      widgetIcon.style.display = '';
      const callbackMode = formFlowEl.getAttribute(CALLBACK_MODE_ATTR_ID);
      if (callbackMode === CALLBACK_MODES.oneToOne || callbackCtaId === 'rcb') {
        // show the lead details modal
        Modal.open(LEAD_DETAILS_MODAL_ID, freezeModal);
      } else {
        // Show the webinar calendly
        openCalendlyModal();
      }
    }
  };

  const closeRequestCallbackContainer = (modalId = null) => {
    if (modalId && ((modalId !== REQUEST_CALLBACK_MODAL)
                    || (modalId !== CONTEXTUAL_CALLBACK_SUCCESS_CONTAINER))) {
      return;
    }
    toggleDisplayStyle(phoneWidget, 'none');
    toggleDisplayStyle(chatWidget, 'none');
    toggleDisplayStyle(whatsAppWidget, 'none');
    toggleCallUsWidget('none');
    toggleDisplayStyle(widgetIcon, '');
    toggleDisplayStyle(widgetClose, 'none');
    formFlowEl?.removeAttribute('data-click-source');

    if (!isDefaultCountry) {
      Modal.close(REQUEST_CALLBACK_MODAL);
    } else {
      floatingContainer.classList.add(requestCallbackHiddenClass);
    }
    resetForm();

    // Reset the UI Fields
    const eventToResetField = new Event('reset-selection');
    document.dispatchEvent(eventToResetField);
  };

  modalEvents.on('backdrop:dismissed', closeRequestCallbackContainer);
  modalEvents.on('dismissed', closeRequestCallbackContainer);

  const openRequestCallbackPopup = (e, cta, program = DEFAULT_PROGRAM) => {
    e.stopPropagation();
    toggleDisplayStyle(phoneWidget, 'none');
    toggleDisplayStyle(chatWidget, 'none');
    toggleDisplayStyle(whatsAppWidget, 'none');
    toggleCallUsWidget('none');
    toggleDisplayStyle(widgetIcon, 'none');
    toggleDisplayStyle(widgetClose, '');
    openCallbackContainer({ callbackCtaId: cta, program });
  };

  // requestCallbackStripActionEl.addEventListener(
  //   'click',
  //   (e) => openRequestCallbackPopup(e, 'rcb'),
  // );

  const setCtaClickAttribution = (intent, program) => {
    setAttribution(intent, {
      program: PROGRAM_PRODUCT_MATCHING[program],
    });
  };

  REQUEST_CALLBACK_CTAS.forEach(([callbackCtaId, cta, program, intent]) => {
    const btns = document.querySelectorAll(`#${callbackCtaId}`);
    if (btns) {
      btns.forEach((btn) => {
        btn.addEventListener(
          'click',
          e => {
            if (
              REQUEST_CALLBACK_CTAS_IN_CLICKABLE_CARDS.includes(callbackCtaId)
            ) {
              e.stopPropagation();
              e.preventDefault();
            }
            if (
              variantValue === rcbModelVariant
              || variantValue2 === rcbModelVariant
            ) {
              return;
            }
            formFlowEl?.setAttribute?.('data-click-source', callbackCtaId);
            openRequestCallbackPopup(e, cta, program || DEFAULT_PROGRAM);
            setCtaClickAttribution(
              intent || DEFAULT_RCB_INTENT,
              program || DEFAULT_PROGRAM,
            );
          },
        );
      });
    }
  });

  chatWidget.addEventListener('click', () => {
    window.openWidget();
    toggleDisplayStyle(contactUsContainer, 'none');
    toggleDisplayStyle(widgetClose, 'none');
    toggleDisplayStyle(widgetIcon, '');
  });

  phoneWidget.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleDisplayStyle(phoneWidget, 'none');
    toggleDisplayStyle(chatWidget, 'none');
    toggleDisplayStyle(whatsAppWidget, 'none');
    toggleCallUsWidget('none');
    setCtaClickAttribution(
      DEFAULT_RCB_INTENT,
      DEFAULT_PROGRAM,
    );
    formFlowEl?.setAttribute?.('data-click-source', CONTACT_US_WIDGET_BUTTON);
    openCallbackContainer({});
  });

  widgetButton.addEventListener('click', (event) => {
    if (
      variantValue === rcbModelVariant
        || variantValue2 === rcbModelVariant
    ) {
      return;
    }
    event.stopPropagation();
    if (widgetIcon.style.display === 'none') {
      closeRequestCallbackContainer();
    } else {
      toggleDisplayStyle(phoneWidget, 'flex');
      toggleDisplayStyle(chatWidget, 'flex');
      toggleDisplayStyle(whatsAppWidget, 'flex');
      toggleCallUsWidget('flex');
      toggleDisplayStyle(widgetIcon, 'none');
      toggleDisplayStyle(widgetClose, '');
    }
  });

  requestCallbackFormCloseEl?.addEventListener('click', (event) => {
    event.stopPropagation();
    closeRequestCallbackContainer();
  });

  const isContactUsPopupDisabled = pathName
  && RCB_CONTACT_US_POPUP_DISABLED_PAGES.some(
    (disabledPage) => pathName.startsWith(disabledPage),
  );

  const shouldAddTalkToUsText = pathName
  && RCB_TALK_TO_US_POPUP_PAGES.some(
    (page) => pathName.startsWith(page),
  );

  if (!isContactUsPopupDisabled) {
    window.addEventListener('scroll', debounce(() => {
      if (
        !isWidgetOpen()
          && !contactUsStripEl.classList.contains(INFO_TEXT_STRIP)
      ) {
        if (shouldAddTalkToUsText) contactUsStripEl.innerText = 'Talk to us';
        contactUsStripEl.classList.remove(
          `${INFO_TEXT_STRIP}--hidden`,
        );
        contactUsStripEl.classList.add(INFO_TEXT_STRIP);
      }
    }, 1000, { leading: true, trailing: false }));

    window.addEventListener('scroll', debounce(() => {
      if (!contactUsStripEl.classList.contains(`${INFO_TEXT_STRIP}--hidden`)) {
        contactUsStripEl.classList.add(`${INFO_TEXT_STRIP}--hidden`);
        contactUsStripEl.classList.remove(INFO_TEXT_STRIP);
      }
    }, 1000));
  }


  const shouldAuthenticateMobile = formFlowEl.getAttribute(
    'data-rcb-enable-mobile-authentication',
  ) === 'true'
  || formFlowEl.getAttribute('data-enable-mobile-authentication') === 'true';
  if (shouldAuthenticateMobile) {
    RequestCallbackFrom.initialize();
  }

  // Handle queryParams
  const handleQueryParams = () => {
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);
    if (queryParams.get(QUERY_PARAMS.openCalendly) === 'true') {
      openCallbackContainer({ callbackCtaId: 'landing' });
    } else if (queryParams.get(QUERY_PARAMS.requestCallback) === 'true') {
      openCallbackContainer({ freezeModal: true });
    }
  };

  handleQueryParams();
  Tracking.initialize();
}
